module.exports = "/_next/static/images/about-us-banner-786b267045bb25d6d343d06ffadbc4ff.svg";